module.exports = __webpack_public_path__ + "static/media/koryubug.997ca97c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/koryubug.png
// module id = 235
// module chunks = 0